import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { operationsLogsChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const OperationsLogsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={operationsLogsChannelName(personId)}>{children}</ChannelProvider>
  );
};

export default OperationsLogsChannel;
